import type {
  ForgotPasswordRequest,
  ForgotPasswordResponse,
  LoginRequest,
  LoginResponse,
  LogoutResponse,
  ResetPasswordRequest,
  ResetPasswordResponse,
  VerifyEmailParams,
  VerifyEmailResponse,
} from '@/types/auth'
import type { User } from '@/types/user'

import { api } from './client'

export const authApi = {
  login: (data: LoginRequest) =>
    api.post<LoginResponse>('/auth/login', data),

  logout: (params?: { returnTo?: string }) =>
    api.post<LogoutResponse>('/auth/logout', undefined, { params }),

  me: () =>
    api.get<User>('/auth/me'),

  forgotPassword: (data: ForgotPasswordRequest) =>
    api.post<ForgotPasswordResponse>('/auth/forgot-password', data),

  resetPassword: (data: ResetPasswordRequest) =>
    api.post<ResetPasswordResponse>('/auth/reset-password', data),

  verifyEmail: (params: VerifyEmailParams) =>
    api.get<VerifyEmailResponse>('/auth/verify', params),
}
